export function ccbNoteKey(projectId: string, tab: string) {
  return `ccb-note:${projectId}:${tab}`;
}

export interface CCBSavedNote {
  tab: string;
  notes: string;
  savedAt: string;
}
